import { SUPPORT_EMAIL } from 'config';

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import Logo from '../../components/Logo';
import SlashCommand from '../../components/SlashCommand';
import SlashCommands from '../../components/SlashCommands';

import facebookImage from './facebook.svg';
import twitterImage from './twitter.svg';
import slackImage from './slack.png';
import sotuImage from './sotu.png';
import slackSmallImage from './slackSmall.png';
import sotuSmallImage from './sotuSmall.png';
import S from './style.css';

export default class WelcomeContent extends Component {
  static propTypes = {
    howTo: PropTypes.bool,
    teamName: PropTypes.string,
  }

  static defaultProps = {
    howTo: false,
  }

  render() {
    const { howTo, teamName } = this.props;

    const QuoteSymbol = ({ children, className = '', style = {} }) => (
      <div
        className={`dtc serif navy pr ${className}`}
      >
        <span
          className="dib overflow-hidden"
          style={{
            fontSize: '8rem',
            height: '4rem',
            ...style
          }}
        >
          {children}
        </span>
      </div>
    );

    const buttonClasses = 'b white no-underline app-bg-blue dib br2';

    return (
      <div>
        <div className="app-bg-gradient lightest-blue">
          <div className={`pv4 ph3 mw8 center ${howTo ? 'tl dt dt--fixed' : 'tc'}`}>
            <div className={`${howTo ? 'dtc w-60-ns v-mid' : ''} center`}>
              <Logo />
            </div>
            {howTo &&
              <div className={`${howTo ? 'dtc w-40-ns v-mid' : ''} tr mt4 mt0-ns`}>
                <Link
                  className={`${buttonClasses} pa2 pv3 pa3-ns f6 f5-ns`}
                  to="/dashboard"
                >
                  View Dashboard
                </Link>
              </div>
            }
          </div>

          {!howTo &&
            <div className="tc ph3">
              <h1 className="m0 serif">
                Nice start! SOTU has been added to {teamName}!
              </h1>
              <div className="f4">
                You've just been sent a welcome message in Slack.
              </div>

              <div className="pv5">
                <Link
                  className={`${buttonClasses} pa3`}
                  to="/dashboard"
                >
                  View Dashboard
                </Link>
              </div>
            </div>
          }


          {/* How to */}
          <div className="tc">
            <div className="f4">
              How to <SlashCommand className="white" suffix=":" />
            </div>

            <div className="dt-l mw8-l center mt4">
              <div className="dtc-l v-btm-l ph3">
                <div className="lh-copy">
                  A team member posts a status by typing
                  {' '}<SlashCommand className="white" />{' '}
                  followed by the status from within the channel.
                </div>
                <div className="mt3" style={{ lineHeight: 0 }}>
                  <img alt="Slack" className="dn db-ns" src={slackImage} />
                  <img alt="Slack" className="dn-ns" src={slackSmallImage} />
                </div>
              </div>
              <div className="dtc-l v-btm-l ph3 mt0-l mt4">
                <div className="lh-copy">
                  The chief or any other team member can go to the dashboard to
                  view the statuses of all team channels.
                </div>
                <div className="mt3" style={{ lineHeight: 0 }}>
                  <img alt="SOTU" className="dn db-ns" src={sotuImage} />
                  <img alt="SOTU" className="dn-ns" src={sotuSmallImage} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* The perfect and quote */}
        <div>
          <div className="dt-l mw8-l pv5-l pv4 ph3 center">

            <div className="dtc-l v-mid-l">
              <div className="serif f4 b navy">
                The perfect <SlashCommand suffix=":" />
              </div>
              <ul className={`pl3 lh-copy ${S.starList}`}>
                <li>40-70 words (240-400 characters)</li>
                <li>thorough enough for a comprehensive overview</li>
                <li>brief enough to quickly digest</li>
              </ul>
            </div>

            <div
              className="dtc-l w-60-l v-mid-l pl4-l mt0-l mt5"
              style={{ color: '#4988c7' }}
            >
              <div className="dt">
                <QuoteSymbol className="v-top" style={{ marginTop: '-2rem' }}>
                  &ldquo;
                </QuoteSymbol>
                <div className="dtc v-mid lh-copy ph2 tc tl-ns">
                  <div>
                    We’re one feature away from pausing feature development for
                    now.  We’ll then turn our energy towards small design
                    updates and bug fixes. The plan is to launch a beta in
                    Australia at the end of the month, so we have two weeks left
                    to button things up before then.
                  </div>
                </div>
                <QuoteSymbol className="v-btm" style={{ marginBottom: '-2rem' }}>
                  &rdquo;
                </QuoteSymbol>
              </div>
            </div>

          </div>
        </div>

        <div
          className="mt5 pv5 tc"
          style={{ backgroundColor: '#d4dbe1' }}
        >
          <div className="serif f4 b mb3 navy">
            Use these commands in any channel:
          </div>

          <SlashCommands />
        </div>

        <div className="app-bg-blue tc pv4 pv5-l white b f3 f2-ns serif">
          Need Help?{' '}
          <a
            className="white"
            href={`mailto:${SUPPORT_EMAIL}`}
          >
            Contact us
          </a>.
        </div>

        <div className="tc mt5">
          <div className="serif f2 b navy">
            Share SOTU!
          </div>
          <div className="tc mt3">
            <a
              className="mh3"
              href="https://facebook.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img alt="Share on Facebook" src={facebookImage} />
            </a>
            <a
              className="mh3"
              href="https://twitter.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img alt="Share on Twitter" src={twitterImage} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/WelcomeContent/index.jsx
 **/